import React from "react";
import { FormControl, Select, MenuItem, Typography, SelectChangeEvent } from "@mui/material";
import { colors } from "../theme/theme";

interface SelectInputProps {
  label: string;
  value: string | number;
  options: string[];
  onChange: (value: string|number) => void;
  disabled?: boolean;
  error?: string | null;
  onFocus?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  required?: boolean;
  // menuPropsStyle: React.CSSProperties;
}
const SelectBox: React.FC<SelectInputProps> = ({
  label,
  value,
  onChange,
  options = [],
  disabled,
  error,
  onFocus,
  onBlur,
  required = false,
  // menuPropsStyle = {},
  ...props
}) => {
  return (
    <div className="form-field">
      {label && (
        <Typography
          className="typography-text"
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontSize: "12px",
            fontWeight: 400,
            color: colors.primary,
            width: "80%",
          }}
          variant="subtitle2"
        >
          {label}
          {required && (
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          )}
        </Typography>
      )}
      <FormControl
        className="text-field"
        sx={{ marginBottom: "0px", marginTop: "8px" }}
        margin="normal"
        size="small"
      >
        <Select
          value={value}
          onChange={(e: SelectChangeEvent<string | number>) =>
            onChange(e.target.value)
          }
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          sx={{
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: '"Inter", sans-serif',
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 200,
                overflow: "auto",
                // ...menuPropsStyle,
              },
            },
          }}
          {...props}
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              value={option}
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                fontFamily: '"Inter", sans-serif',
              }}
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {error && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default SelectBox;
